/*
 * Reverse-geocodes a lat/long to a place name, with a 24h localStorage cache.
 *
 * Called from store-locator.min.js (geolocate_) to prefill the store finder's
 * location search box after the browser grants location permission.
 *
 * This file previously also carried a "nearest store" cookie feature copied
 * from the Daiwa theme. It never ran here: it depended on #panel-hide and
 * #map-canvas-hide, which exist in Daiwa's header but were never added to this
 * theme, so it threw on every page load for visitors without the cookie.
 * Removed 2026-08-28 along with its orphaned caller, nearest-locator.min.js.
 */
window.getLocationCityLatLon = async function(lat,lon){
  var cacheKey = 'geocode_' + lat + '_' + lon;
  var cacheExpiryKey = 'geocodeExpiry_' + lat + '_' + lon;
  var cacheExpiryHours = 24; // Cache for 24 hours

  // Check if cached data exists and is not expired
  var cachedData = localStorage.getItem(cacheKey);
  var cachedExpiry = localStorage.getItem(cacheExpiryKey);
  var now = new Date().getTime();

  if (cachedData && cachedExpiry && now < parseInt(cachedExpiry)) {
    // Use cached data
    return JSON.parse(cachedData);
  } else {
    // Fetch new data
    var response = await $.getJSON('https://maps.googleapis.com/maps/api/geocode/json?latlng='+ lat + ',' + lon +'&key=AIzaSyBxndKCpLv4kwiAu16Rvs-2acYybb_HQeo', function() {});
    // Cache the data
    localStorage.setItem(cacheKey, JSON.stringify(response));
    localStorage.setItem(cacheExpiryKey, (now + cacheExpiryHours * 60 * 60 * 1000).toString());
    return response;
  }
}
